import { injectable } from 'inversify';
import Axios, { AxiosPromise } from 'axios';

import Types from '../../AuthorisationTypes';
import { Misc, Model } from '@singularsystems/neo-core';
import { UserGroupRolesLookup } from '../../Models/UserRoleLookup';

export interface IUsersApiClient {
    /**
     * Will get a list of users
     */
    getLookupAsync(): AxiosPromise<any>;

    /**
     * Will get a list of user roles
     */
    getRoleLookupAsync(userId: string): AxiosPromise<Array<Model.PlainObject<UserGroupRolesLookup>>>;

    /**
     * Gets the user's list of memberships
     */
    getCurrentUserRoles(): AxiosPromise<Array<Model.PlainObject<UserGroupRolesLookup>>>;
}

@injectable()
export default class UsersApiClient implements IUsersApiClient {

    private apiPath: string;

    constructor(
        config = Misc.Globals.appService.get(Types.Config.ConfigModel)) {

        this.apiPath = `${config.authorisationServerApiPath}/Users`;
    }

    public getLookupAsync() {
        return Axios.get(`${this.apiPath}/Lookup/`);
    }

    public getRoleLookupAsync(userId: string): AxiosPromise<Array<Model.PlainObject<UserGroupRolesLookup>>> {
        return Axios.get(`${this.apiPath}/Roles/${userId}`);
    }

    public getCurrentUserRoles(): AxiosPromise<Array<Model.PlainObject<UserGroupRolesLookup>>> {
        return Axios.get(`${this.apiPath}/currentUserRoles`);
    }
}
